import { Grid, Stack } from '@mui/material'

import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { FileAPIUpload } from 'components/common/FileAPIUpload'
import { UploadVisualsStepKey } from './ClientPropertySelfUploadPopup.controller'
import { supportedImageFileTypes } from 'constants/misc'
import { useTranslation } from 'react-i18next'

export const UploadVisualsStep: FC = () => {
  const { t } = useTranslation(['self_upload_popup'])

  return (
    <DynamicFlowStep
      stepKey={UploadVisualsStepKey.UPLOAD_PHOTOS}
      isValid={true}
    >
      <Stack alignItems="flex-start" gap={3} padding="0 0 1.6rem 0">

        <FileAPIUpload
          boxElevation='none'
          borderBoxColor='transparent'
          showFileListing={false}
          files={[]}
          acceptedFileTypes={supportedImageFileTypes}
          uploadHandler={() => { }}
        />

        <Grid container spacing={1}>
          <Grid item xs={3}>
            {/* Images */}
          </Grid>
        </Grid>

      </Stack>
    </DynamicFlowStep>
  )
}
